import { useEffect, useRef } from "react";

const ParallaxDivider = ({ image, sideImages }: { image: string; sideImages?: [string, string] }) => {
  const parallaxRef = useRef<HTMLDivElement>(null);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let rafId: number;
    const handleScroll = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        if (parallaxRef.current && sectionRef.current) {
          const rect = sectionRef.current.getBoundingClientRect();
          const windowH = window.innerHeight;
          if (rect.bottom > 0 && rect.top < windowH) {
            const progress = (windowH - rect.top) / (windowH + rect.height);
            parallaxRef.current.style.transform = `translateY(${(progress - 0.5) * -250}px)`;
          }
        }
      });
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (sideImages) {
    return (
      <div
        ref={sectionRef}
        className="relative h-[400px] md:h-[500px] overflow-hidden border-y border-border/30"
      >
        <div
          ref={parallaxRef}
          className="absolute -inset-[150px] grid grid-cols-2 will-change-transform"
        >
          <img src={sideImages[0]} alt="" className="w-full h-full object-cover object-center" loading="lazy" />
          <img src={sideImages[1]} alt="" className="w-full h-full object-cover object-center" loading="lazy" />
        </div>
        <div className="absolute inset-0 bg-background/30" />
      </div>
    );
  }

  return (
    <div
      ref={sectionRef}
      className="relative h-[400px] md:h-[500px] overflow-hidden border-y border-border/30"
    >
      <div
        ref={parallaxRef}
        className="absolute -inset-[150px] bg-cover bg-center will-change-transform"
        style={{ backgroundImage: `url('${image}')` }}
      />
      <div className="absolute inset-0 bg-background/30" />
    </div>
  );
};

export default ParallaxDivider;
